import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import { Tooltip } from 'primereact/tooltip';
import classes from "./CalendarPicker.module.css";
import { DateCalendarIcon } from "../../constant";
import clsx from "clsx";

const CalendarPicker = ({
  disabled,
  value,
  onChange,
  label,
  isOptional,
  labelStyle,
  errorText,
  tooltip = true,
  showTooltip = true,
  icon = <DateCalendarIcon className={classes.leftIcon} />,
  showTime,
  timeOnly,
  placeholder,
  minDate,
  maxDate,
  showIcon,
  ...rest
}) => {
  const [isHovered, setIsHovered] = useState(false);

  // Get today's date for min date restriction
  const today = new Date().setHours(0, 0, 0, 0);

  // Convert the value to a Date object if it's not already
  const dateValue = value ? new Date(value) : null;

  return (
    <div
      className={classes.group}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {label && (
        <label
          htmlFor="calendar-input"  // Added unique ID
          className={clsx(classes.labelText, {
            [classes.labelDisabled]: disabled,
          })}
          style={labelStyle}
        >
          {label} {" "}
          {!isOptional && <span className={clsx("steric")}>*</span>}
        </label>
      )}

      {/* Wrap the Calendar in a tooltip container */}
      <div
        className={clsx(classes.container, {
          [classes.disabled]: disabled,
        })}
        data-pr-tooltip={showTooltip ? tooltip : null}
        data-pr-position="right"  // You can adjust tooltip position
        data-pr-at="right+5 top"  // Adjust offset if needed
      >
        <Calendar
          id="calendar-input"  // Added unique ID
          disabled={disabled}
          placeholder={placeholder}
          value={dateValue}
          showTime={showTime}
          timeOnly={timeOnly}
          hourFormat="12"
          timeFormat="hh:mm a"
          onChange={(e) => {
            onChange(e?.value)
          }}
          showIcon
          icon={icon}
          // minDate={today}  // Restrict past dates
          hideOnDateTimeSelect  // Hide calendar after selection
          showButtonBar  // Optional: adds Today/Clear buttons
          className={clsx("w-full", {  // Added full width class
            [classes.calendarDisabled]: disabled
          })}
          {...rest}
        />
      </div>

      {errorText && <p className={"errorText"}>{errorText}</p>}

      {/* Make sure Tooltip component is mounted */}
      {showTooltip && tooltip && (
        <Tooltip
          target={`.${classes.container}`}  // Target the container div
          position="right"
          showDelay={50}
        />
      )}
    </div>
  );
};

export default CalendarPicker;